'use client';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = theme => ({
  modalRoot: {
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
    },
    '& .MuiBackdrop-root': {
      '@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none)': {
        background: theme?.palette?.default?.modalBoxShadow,
        backdropFilter: 'blur(4.5px)',
      },
      '@supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none))': {
        background: theme?.palette?.default?.modalBoxShadow,
      },
    },
  },
  arrowIcon: {
    color: theme?.palette?.default?.buttonColor,
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'calc(100% - 6.75rem)',
    maxWidth: 900,
    bgcolor: 'background.paper',
    borderRadius: '0.625rem',
    boxShadow: 24,
    paddingBottom: '8.75rem',
    background: theme?.palette?.default?.backgroundColor2,
    outline: 'none',

    '&::-webkit-scrollbar': {
      width: '0.2rem',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: `inset 0 0 6px ${theme?.palette?.default?.scrollBarBoxShadow}`,
      webkitBoxShadow: `inset 0 0 6px ${theme?.palette?.default?.scrollBarBoxShadow}`,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme?.palette?.default?.buttonColor,
      outline: '0.25rem solid transparent',
      borderRadius: '10rem',
    },

    [theme.breakpoints.between('md', 'lg')]: {
      paddingBottom: '8rem',
      width: 'calc(100% - 3.75rem)',
      maxWidth: 700,
    },
    [theme.breakpoints.up('sm')]: {
      maxHeight: '90vh',
      overflow: 'auto',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      pb: '3rem',
    },

    [theme.breakpoints.down('sm')]: {
      position: 'inherit',
      top: 'unset',
      left: 'unset',
      WebkitTransform: 'unset',
      transform: 'unset',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'unset',
      margin: '3rem 1.5rem 0 1.5rem',
      padding: 0,
      height: '100%',
      width: 'auto',
      borderRadius: '0.625rem 0.625rem 0rem 0rem',
    },
  },
  iconButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  iconButton: {
    p: '1.5rem 1.75rem 1rem 1rem',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
  },
  modalStyle: {
    width: '100%',
    height: '100%',
    position: 'relative',
    objectFit: 'cover',
    objectPosition: 'top',
  },
  modalImage: {
    objectFit: 'cover',
    borderRadius: '0.625rem 0.625rem 0 0',
  },

  imageAndText: {
    pt: '4.1rem',
    [theme.breakpoints.down('sm')]: {
      p: 0,
      display: 'flex',
      maxHeight: 'unset',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '10.938rem',
    },
  },
  descriptionBox: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('sm')]: {
      flexGrow: 0,
    },
  },
  imgIconstyle: {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    position: 'inherit',
    objectFit: 'cover',
  },
  modalheaderstyle: {
    textAlign: 'center',
    color: theme?.palette?.default?.textColor3,
    padding: '0rem 11.25rem',
    margin: '1rem 0rem 1rem 0rem',
    lineHeight: 'initial',
    [theme.breakpoints.down('sm')]: {
      padding: '0rem 1.5rem',
      margin: 0,
      textAlign: 'left',
      mt: 1,
    },
    [theme.breakpoints.between('sm', 'md')]: {
      padding: '0rem 8rem',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      padding: '0rem 8rem',
      margin: '4rem 0rem 1rem 0rem',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '0rem 13rem',
      margin: '4rem 0rem 1rem 0rem',
    },
  },
  textstyle: {
    textAlign: 'center',
    color: theme?.palette?.default?.textColor3,
    padding: '0rem 2rem',
    margin: '0.5rem 0rem 2rem 0rem',

    [theme.breakpoints.down('sm')]: {
      p: '0 1.5rem',
      textAlign: 'left',
      margin: '1rem 0 0 0',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      // padding: '0rem 2.5rem',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      // padding: '0rem 2.5rem',
    },
    [theme.breakpoints.up('lg')]: {
      p: '1rem 13rem',
    },
  },

  cta: {
    minWidth: '16.5rem',
    p: '0.5rem',
    textTransform: 'inherit',
    border: `0.063rem solid ${theme?.palette?.default?.backgroundColor4}`,
    '&:hover': {
      border: `0.063rem solid ${theme?.palette?.default?.backgroundColor4}`,
    },
    '&.Mui-disabled': {
      background: `${theme.palette.default.buttonInactiveColor}`,
      border: `0.063rem solid ${theme?.palette?.default?.backgroundColor4}`,
      color: `${theme.palette.default.textColor}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  ctaContainer: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      p: '2.875rem 1.5rem 0 1.5rem',
    },
  },
  text: {
    background: 'none',
    border: 'unset',
    color: theme?.palette?.default?.buttonColor,
    '&:hover': {
      background: 'none',
      color: theme?.palette?.default?.buttonPrimaryHoverColor,
    },
  },
  outlined: {
    background: theme?.palette?.default?.textColor,
    border: `0.1875rem solid ${theme?.palette?.default?.buttonColor}`,
    color: theme.palette.default.buttonColor,
    '&:hover': {
      border: `0.1875rem solid ${theme?.palette?.default?.buttonColor}`,
      background: theme?.palette?.default?.buttonColor,
      color: theme?.palette?.default?.textColor,
    },
  },
  disclaimer: {
    p: '1rem 13.25rem',
    display: 'flex',
    justifyContent: 'center',
    '& a': {
      textDecoration: 'underline',
    },
    [theme.breakpoints.down('sm')]: {
      p: '1rem 2rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      p: '1rem 7rem',
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      p: '1rem 8rem',
    },
  },
  disclaimerText: {
    color: theme?.palette?.default?.textColor3,
    lineHeight: '1.1rem',
    [theme.breakpoints.down('sm')]: {
      lineHeight: '1.1rem',
    },
  },
});
